// tslint:disable: no-parameter-reassignment

import { JSONObject, JSONValue } from '../../class/workflow.type';

/**
 * Object but not array
 * @param ref object reference to test
 */
const isJsonObject = (ref: JSONValue): boolean => ref && typeof ref === 'object' && !Array.isArray(ref);

/**
 * Deep merge JSON objects
 * Arrays will be replaced
 * @param target to merge to
 * @param updates mergables, right precedence
 */
export const mergeJson = (target: JSONValue, ...updates: JSONValue[]): JSONValue => {
  for (const update of updates) {
    if (isJsonObject(target)) {
      if (isJsonObject(update)) {
        for (const key of Object.keys(update)) {
          if (isJsonObject(target[key]) && isJsonObject(update[key])) {
            mergeJson(target[key], update[key]);
          } else {
            target[key] = Array.isArray(update[key]) ? [...update[key]] : update[key];
          }
        }
      } else {
        // update is not an json object
        target = Array.isArray(update) ? [...update] : update;
      }
    } else {
      // target is not an json object
      target = Array.isArray(update) ? [] : {};
      Object.assign(target, update);
    }
  }
  return target;
};

/**
 * Delete every key on an object
 * @param obj target
 */
export const truncateObject = (obj: JSONObject): void => {
  for (const key of Object.keys(obj)) {
    delete obj[key];
  }
};
